import { FC } from "react";
import styled from "styled-components";
import { color, fonts } from "@styles";

interface Props {
  data: { cookie: string; provider: string }[];
  cookieHeader: string;
  providerHeader: string;
}

export const CookieTable: FC<Props> = ({ data, cookieHeader, providerHeader }) => (
  <Table>
    <thead>
      <tr>
        <Th>{cookieHeader}</Th>
        <Th>{providerHeader}</Th>
      </tr>
    </thead>
    <tbody>
      {data.map(({ cookie, provider }, index) => (
        <tr key={`${cookie}-${index}`}>
          <Td>{cookie}</Td>
          <Td>{provider}</Td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export const Table = styled.table`
  width: 100%;
  color: ${color.B1100};
`;

export const Th = styled.th`
  font-family: ${fonts.body};
  font-size: 1rem;
  font-weight: 700;
`;

export const Td = styled.td`
  font-family: ${fonts.body};
  font-size: 1rem;
`;
